

import React, { Component } from 'react';
import './Style.css';
import '../../../custom.css'
import { Alert } from '../../Utils/Alert';
import { Loading } from '../../Utils/Loading';

export class Seniority extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isPost: false,
            loading: false,
            seniority: [],
            alert: {
                Title: '',
                Body: '',
                Type: '',
                Show: false
            }
        }
    }

    componentDidMount() {
        this.GetSeniorityByUserId();
    }

    componentDidUpdate() {
      
    }

    async GetSeniorityByUserId() {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Profile/GetSeniorityByUserId`, request);

        this.setState({ loading: false });

        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ seniority: data });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Cargando los planes por tema',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    render() {

        return (
            <div className="col-lg-12 row mt-5">

                <div class="panel-group" id="accordion">
                    {
                        this.state.seniority.map(a => <div class="panel panel-default">
                            <div class="panel-heading">
                                <h4 class="panel-title">
                                    <a data-toggle="collapse" data-parent="#accordion" href={`#collapse${a.id}`}>
                                        { a.title }</a>
                                </h4>
                                <a href={`/comunidad/mi-perfil/seniority/${a.id}`}>Editar</a>
                            </div>
                            <div id={`collapse${a.id}`} class="panel-collapse collapse in">
                                <div class="panel-body">
                                    <div className="col-lg-12 text-center">
                                        <img src={a.logo} className="w-100"></img>
                                    </div>
                                    <div className="col-lg-12 row mt-3">
                                        <div className="col-lg-6">
                                            <img src={a.photoTeam} className="w-100"></img>
                                        </div>
                                        <div className="col-lg-6">
                                            <img src={a.photoTeamSeniority} className="w-100"></img>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-3">
                                        <p>{a.vision}</p>
                                    </div>

                                    <div className="row mt-5 col-lg-12">
                                        <div className="col-lg-6">
                                            <p><b>Nombre de mi buddy:</b> {a.buddyName}</p>
                                        </div>
                                        <div className="col-lg-6">
                                            <p><b>Contrato de mi buddy:</b> {a.contractBuddy }</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        )
                    }
                </div>

                <div className="col-lg-12 text-center mt-5">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16">
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                    </svg>
                    <a href="/comunidad/mi-perfil/seniority">Agregar seniorato</a>
                </div>
             
                {this.state.alert.Show ? <Alert Title={this.state.alert.Title} Type={this.state.alert.Type} Body={this.state.alert.Body} callBack={() => { this.setState({ alert: { show: false } }) }} /> : null}
                {this.state.loading ? <Loading /> : null}
            </div>
        );
    }
}
